import { render, staticRenderFns } from "./scrollspy.vue?vue&type=template&id=8b5bb9c6&"
import script from "./scrollspy.vue?vue&type=script&lang=js&"
export * from "./scrollspy.vue?vue&type=script&lang=js&"
import style0 from "./scrollspy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports